
import { FC } from 'react';
import { FontAwesomeIcon, FontAwesomeIcons } from 'src/constants/fontAwesomeIcons';
import { useTheme } from '../../../contexts/ThemeContext';

import './ThemeButton.scss';

const ThemeButton: FC = () => {
    const { light, setTheme } = useTheme();

    return (
        <button
            className="theme-button"
            aria-label={light ? "Switch to dark theme" : "Switch to light theme"}
            aria-pressed={light}
            onClick={() => {
                setTheme(!light);
            }}
            type="button"
        >
            {
                light ?
                    <FontAwesomeIcon 
                        className="theme-button-icon"
                        icon={FontAwesomeIcons.Duotone.SUN} 
                        fixedWidth
                    /> :
                    <FontAwesomeIcon 
                        className="theme-button-icon"
                        icon={FontAwesomeIcons.Duotone.MOON} 
                        fixedWidth
                    />
            }
        </button>
    );
}


export default ThemeButton;
